import e from "../../../../../../../_virtual/index3.js";
function sourceFrom(e2) {
  return { sourceIndex: e2.sourceIndex ?? 0, source: e2.source };
}
function sortCompoundSelectorsInsideComplexSelector(o2) {
  const t = [];
  let r = [];
  o2.each(((o3) => {
    if ("combinator" === o3.type) return t.push(r, [o3]), void (r = []);
    if (e.isPseudoElement(o3)) return t.push(r), void (r = [o3]);
    if ("universal" === o3.type && r.find(((e2) => "universal" === e2.type))) o3.remove();
    else {
      if ("tag" === o3.type && r.find(((e2) => "tag" === e2.type))) {
        o3.remove();
        const t2 = e.selector({ value: "", ...sourceFrom(o3) });
        t2.append(o3);
        const n2 = e.pseudo({ value: ":is", ...sourceFrom(o3) });
        return n2.append(t2), void r.push(n2);
      }
      r.push(o3);
    }
  })), t.push(r);
  const n = [];
  for (let e2 = 0; e2 < t.length; e2++) {
    const o3 = t[e2];
    o3.sort(((e3, o4) => selectorTypeOrder(e3) - selectorTypeOrder(o4))), n.push(...o3);
  }
  o2.removeAll();
  for (let e2 = n.length - 1; e2 >= 0; e2--) n[e2].remove(), n[e2].parent = o2, o2.nodes.unshift(n[e2]);
}
function selectorTypeOrder(t) {
  return e.isPseudoElement(t) ? o.pseudoElement : o[t.type];
}
const o = { universal: 0, tag: 1, pseudoElement: 2, nesting: 3, id: 4, class: 5, attribute: 6, pseudo: 7, comment: 8 };
function resolveNestedSelector(o2, t, r) {
  const n = [];
  for (let s2 = 0; s2 < o2.nodes.length; s2++) {
    const c = o2.nodes[s2].clone();
    {
      let o3 = false;
      c.walkNesting((() => (o3 = true, false))), o3 ? "combinator" === c.nodes[0]?.type && c.prepend(e.nesting({ ...sourceFrom(c) })) : (c.prepend(e.combinator({ value: " ", ...sourceFrom(c) })), c.prepend(e.nesting({ ...sourceFrom(c) })));
    }
    {
      const e2 = /* @__PURE__ */ new Set();
      c.walkNesting(((o3) => {
        const r2 = o3.parent;
        r2 && (e2.add(r2), "pseudo" === r2.parent?.type && ":has" === r2.parent.value?.toLowerCase() ? o3.replaceWith(...prepareParentSelectors(t, true)) : o3.replaceWith(...prepareParentSelectors(t)));
      }));
      for (const o3 of e2) sortCompoundSelectorsInsideComplexSelector(o3);
    }
    c.walk(((e2) => {
      "combinator" === e2.type && "" !== e2.value.trim() ? (e2.rawSpaceAfter = " ", e2.rawSpaceBefore = " ") : (e2.rawSpaceAfter = "", e2.rawSpaceBefore = "");
    })), n.push(c);
  }
  const s = e.root({ value: "", ...sourceFrom(o2) });
  return n.forEach(((e2) => {
    s.append(e2);
  })), s;
}
function prepareParentSelectors(o2, t = false) {
  if (t || !isCompoundSelector(o2.nodes)) {
    const t2 = e.pseudo({ value: ":is", ...sourceFrom(o2) });
    return o2.nodes.forEach(((e2) => {
      t2.append(e2.clone());
    })), [t2];
  }
  return o2.nodes[0].nodes.map(((e2) => e2.clone()));
}
function isCompoundSelector(o2) {
  return 1 === o2.length && !o2[0].nodes.some(((o3) => "combinator" === o3.type || e.isPseudoElement(o3)));
}
export {
  resolveNestedSelector
};
//# sourceMappingURL=index.js.map
